import { jsx as _jsx } from "react/jsx-runtime";
import { BUCKET_FILTER } from '@as-react/common-types';
import { FilterSelectList } from './FilterSelectList';
export const FilterItemContentBucketFilter = ({ desktop, filter, onFilterItemChange, }) => (_jsx(FilterSelectList, { desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, type: BUCKET_FILTER }));
